/**
 * @description: 共享股东资料报表
 * @author: lyr
*/
<template>
    <div class="mr-ggzl-report">
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="注册时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="list_form.content">
                        <el-select class="el-slot-select" v-model="list_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="股东卡号" value="vip_card"></el-option>
                            <el-option label="股东手机号" value="vip_mobile"></el-option>
                            <el-option label="股东姓名" value="vip_name"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="会员等级">
                    <el-select v-model="list_form.level" filterable clearable placeholder="请选择会员等级">
                        <el-option v-for="item in vip_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listtExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-row class="total-txt">
                <div class="item">分红总额：{{bonus_total}}</div>
                <div class="item">提现总额：{{withdrawal_amount_total}}</div>
                <div class="item">剩余分红总额：{{remain_total_bonus}}</div>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="activation_time" label="注册时间"></el-table-column>
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="vip_level_name" label="会员等级"></el-table-column>
                <el-table-column prop="vip_card" label="股东卡号"></el-table-column>
                <el-table-column prop="username" label="股东姓名"></el-table-column>
                <el-table-column prop="mobile" label="股东手机号"></el-table-column>
                <el-table-column prop="come_shop_num" label="到店次数"></el-table-column>
                <el-table-column prop="consumption" label="累计消费"></el-table-column>
                <el-table-column prop="bonus" label="累计分红"></el-table-column>
                <el-table-column prop="withdrawal_amount" label="累计提现"></el-table-column>
                <el-table-column prop="remain_total_bonus" label="剩余分红"></el-table-column>
                <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="setPageParams(scope.row, 'ggky')">客源详情</span>
                        <span class="text-blue" @click="setPageParams(scope.row, 'ggfm')">分红详情</span>
                        <span class="text-blue" @click="setPageParams(scope.row,'ggtm')">提现详情</span>
                        <span class="text-blue" @click="openWithdrawalPop(scope.row)" v-if="withdrawal_op">线下提现</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 线下提现弹窗 -->
        <div class="withdrawal-pop ele-hide" ref="withdrawal_pop">
            <el-form label-width="80px">
                <el-form-item label="股东">{{withdrawal_form.username}} {{withdrawal_form.mobile}}</el-form-item>
                <el-form-item label="剩余分红">{{withdrawal_form.remain_total_bonus}}</el-form-item>
                <el-form-item label="提现金额">
                    <el-input v-model="withdrawal_form.amount" placeholder="请输入提现金额"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="withdrawal_form.remark" placeholder="请输入备注内容"></el-input>
                </el-form-item>
                <el-form-item label="登录密码">
                    <el-input v-model="withdrawal_form.pwd" 
                        placeholder="请输入账号登录密码进行验证" 
                        type="password"
                        autocomplete="off" 
                        readonly
                        onfocus="this.removeAttribute('readonly')" 
                        onblur="this.setAttribute('readonly', true)">
                    </el-input>
                </el-form-item>
                <div class="red-tip">注：确认提现后，数据将不可逆，请谨慎操作</div>
            </el-form>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'ggzl-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                vip_list: [],
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    content: '',
                    select: 'vip_card',
                    level: '',
                },
                bonus_total: 0,
                withdrawal_amount_total: 0,
                remain_total_bonus: 0,
				list_table: [],
				list_page: 1,
                list_total: 0,
                mr_ggky_menu: {}, // 共享股东客源报表菜单
                mr_ggfm_menu: {}, // 共享股东分红明细报表菜单
                withdrawal_form: {
                    id: '',
                    amount: '',
                    remark: '',
                    pwd: '',
                },
                withdrawal_op: false, // 线下提现权限
            }
        },
        computed: {
            menunew() {
                return JSON.parse(this.$store.state.menunew)
            },
        },
        mounted: function() {
            // 跳转菜单
            this.getPageMenu();
            // 获取相关权限设置
            this.getMenuOp()
            // 日期
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getVipLevelCombo()
                this.getList(1);
            })
        },
        methods: {
            // 跳转菜单
            getPageMenu: function() {
                this.menunew.forEach(i => {
                    if(i.id == '544') {
                        i.submenu.forEach(j => {
                            if(j.id == '567') {
                                j.submenu.forEach(k => {
                                    if(k.id == '1076') {
                                        // 共享股东客源报表
                                        this.mr_ggky_menu = k
                                    }
                                    if (k.id == '1077') {
                                        // 共享股东分红明细报表
                                        this.mr_ggfm_menu = k
                                    }
                                    if (k.id == '1160') {
                                        //共享股东提现明细报表
                                        this.mr_ggtm_menu = k
                                    }
                                })
                            }
                        })
                    }
                })
            },
            // 跳转参数
            setPageParams(row, name) {
                if (name == 'ggky') {
                    const obj = {
                        name: 'mr_ggky_report',
                        params: {
                            shareholder_vip_card: row.vip_card
                        }
                    }
                    this.$emit("pageLink", this.mr_ggky_menu, obj)
                }else if (name == 'ggfm') {
                    const obj = {
                    name: 'mr_ggfm_report',
                        params: {
                            shareholder_vip_card: row.vip_card
                        }
                    }
                    this.$emit("pageLink", this.mr_ggfm_menu, obj)
                }else if (name == 'ggtm') {
                    const obj = {
                    name: 'mr_ggtm_report',
                        params: {
                            vip_card: row.vip_card
                        }
                    }
                    this.$emit("pageLink", this.mr_ggtm_menu, obj)
                }
            },

            // 获取权限
            getMenuOp() {
                let _this = this,
                    menu = JSON.parse(this.$store.state.menunew);

                menu.forEach(f => {
                    if(f.id == '544') { // 报表
                        menu = f.submenu
                        menu.forEach(s => {
                            if(s.id == '567') { // 会员报表
                                menu = s.submenu
                                menu.forEach(v => {
                                    if (v.id == '1075') { // 共享股东会员资料报表
                                        menu = v.submenu
                                        console.log(menu)
                                    }
                                })
                            }
                        })
                    }
                })
                menu.forEach(_ => {
                    if(_.id == '1159') {
                        _this.withdrawal_op = true
                    }
                })
            },

            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },

            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取会员卡等级
            getVipLevelCombo: function() {
                const _this = this;

                Vue.axios.post('Vip/getVipLevelCombo', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.vip_list = res.data.response.result;
                        _this.vip_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

                _this.loading = true;
                let vip_card = "",
                    vip_name = "",
                    vip_mobile = "";
                if(_this.list_form.select == 'vip_card') {
                    vip_card = _this.list_form.content;
                } else if(_this.list_form.select == 'vip_name') {
                    vip_name = _this.list_form.content;
                } else if(_this.list_form.select == 'vip_mobile') {
                    vip_mobile = _this.list_form.content;
                }
				Vue.axios.post('FinanceReport2/getVipShareholderList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                            "vip_card": vip_card,
                            "username": vip_name,
                            "mobile": vip_mobile,
                            "level": _this.list_form.level
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.data.total);
							_this.bonus_total = res.data.response.result.data.bonus_total;
							_this.withdrawal_amount_total = res.data.response.result.data.withdrawal_amount_total;
                            _this.remain_total_bonus = res.data.response.result.data.remain_total_bonus;
						}
						_this.list_table = res.data.response.result.data.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },

            openWithdrawalPop(row) {
                let _this = this
                _this.withdrawal_form = {
                    id: row.id,
                    amount: '',
                    remark: '',
                    pwd: '',
                    username: row.username,
                    mobile: row.mobile,
                    remain_total_bonus: row.remain_total_bonus
                }

                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['线下提现', true],
                    area: ['450px', '520px'], // 宽高
                    content: $(_this.$refs.withdrawal_pop),
                }, function() {
                    if ((_this.withdrawal_form.amount - 0 ) > (_this.withdrawal_form.remain_total_bonus - 0)){
                        layer.msg("提现金额不得大于剩余分红")
                        return
                    }
                    if (_this.withdrawal_form.amount == '') {
                        layer.msg("请输入提现金额")
                        return
                    }
                    if (_this.withdrawal_form.pwd == '') {
                        layer.msg("请输入登录密码")
                        return
                    }
                    Vue.axios.post('VipShareholder/withdrawal', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": _this.withdrawal_form
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            layer.closeAll()
                            layer.msg("手动提现成功！")
                            _this.getList(_this.list_page)
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                });
            },

            listtExport: function() {
                let vip_card = "",
                    vip_name = "",
                    vip_mobile = "";
                if(this.list_form.select == 'vip_card') {
                    vip_card = this.list_form.content;
                } else if(this.list_form.select == 'vip_name') {
                    vip_name = this.list_form.content;
                } else if(this.list_form.select == 'vip_mobile') {
                    vip_mobile = this.list_form.content;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/exportVipShareholderList" +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&vip_card=" + vip_card +
                    "&username=" + vip_name +
                    "&mobile=" + vip_mobile +
                    "&level=" + this.list_form.level;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .total-txt {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .item {
            margin-right: 40px;
        }
    }
    .withdrawal-pop {
        .red-tip {
            text-align: center;
            color: red;
        }
    }
</style>